<template>
  <div>
    <v-img
      :key="locale"
      v-if="prepareURL(data && data.ImageTranslateURL ? data.ImageTranslateURL : null, locale)"
      :style="{ 'width': isSimulation ? '375px' : `${sizeW}px !important`}"
      :src="prepareURL(data && data.ImageTranslateURL ? data.ImageTranslateURL : null, locale)"
    />
  </div>
</template>

 <script>
import { mapState } from 'vuex' 
  import constants from '@/constants'
  import utils from '@/services/utils'
  export default {
    props: {
      data: {
        type: Object,
        required: true,
        default: null
      },
    },
    data () { 
      return {
        url: null,
      }
    },
    computed: {
      ...mapState('app',['locale']),
      isSimulation () {
        return constants.simulationsRutes.indexOf(this.$route.path.split('/')[1]) >= 0
      },
      sizeW () {
        return window.innerWidth - (!utils.isMobile() ? 360 : 0)
      }
    },
    watch: {
      locale () {
        this.handleChangeURL()
      },
      'data.ImageTranslateURL' () {
        this.handleChangeURL()
      },
    },
    mounted () {
      this.handleChangeURL()
    },
    methods: {
      prepareURL (v, locale) {
        if (!v) return null
        return utils.getTranslation(v, locale)
      },
      handleChangeURL () {
        this.url = this.data && this.data.ImageTranslateURL ? utils.getTranslation(this.data.ImageTranslateURL, this.locale) : null
      },
    },
  }
</script>
